<template>
    <div>
        <redeem-button
            :isLogin="isLogin"
            :point="availablePoint"
            :selectedPoint="selectedPoint"
            :selectedQuantity="selectedQuantity"
            :lblRedeemBTN="lbl.redeem_button"
            :campaign="campaign"
            :redeemBTN="redeemBTN"
            v-if="isForceRender && checkLoadingLogin"
            @clickRedeem="clickRedeem()">
        </redeem-button>

    <modal
        view="redeem-component"
        :busModal="busModal"
        @modalAlertHidden="clickOkModalAlert($event)"
    ></modal>

    <confirm-redeem-modal
        :lbl="lbl"
        :campaign="campaign"
        :busModal="busConfirmRedeem"
        @clickConfirmRedeem="clickConfirmRedeem()"
    ></confirm-redeem-modal>

    <serial-modal :lbl="lbl" :busSerialModal="busSerialModal"></serial-modal>

    <shipping-address-modal
        :lblShipping="lbl.shipping"
        :shippingAddress="shippingAddress"
        :errorInfo="shippingAddressValidateInfo"
        :busShippingModal="busShippingModal"
        @clickConfirmAddress="clickConfirmAddress($event)"
    ></shipping-address-modal>

  </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Account from "@/helper/AccountHelper.js";
import RedeemButton from "@/components/campaign/detail/RedeemButton.vue";
import Locale from "@/helper/locale/locale.js";
//Service
import BzbsCampaign from "@/service/BzbsCampaign.js";
import {
  CampaignConfigBuilder,
  RedeemConfigBuilder,
  RedeemShippingAdressBuilder,
} from "@/service/config/CampaignConfigModel.js";
//Modal
import Modal from "@/components/modal/Modal.vue";
import ConfirmRedeemModal from "@/components/modal/ConfirmRedeemModal.vue";
import SerialModal from "@/components/modal/SerialModal.vue";
import ShippingAddressModal from "@/components/modal/ShippingAddressModal.vue";
/**
 * Property
 * @property {object} lbl Text for Component.
 * @property {object} campaign Campaign model.
 * @property {number} selectedId Selected campaign for redeem in case of campaign contain sub-campaign.
 * @property {number} selectedQuantity Selected campaign quantity.
 * @property {number} selectedPoint Selected campaign use/get point.
 * Event
 * @event clickRedeem Click validate redeem.
 * @event clickConfirmRedeem Click confirm to proceed redeem define type of campaign.
 * Method
 * @method checkRedeemCondition Check if user can or cannot redeem.
 * @method openWebsite Redirect by campaign condition to website after redeem.
 * @method openSurvey Redirect by campaign condition to website after redeem.
 * @method callInterfaceApi Call api by campaign condition after redeem.
 * @method initialShippingAddress Setup data model and open shipping address modal.
 * @method clickConfirmAddress Validate shipping address and proceed redeem.
 * @method redeem Call redeem api for redeem.
 * @method updateCampaign Call Campaign detail api to update data.
 * @method updateCampaignInfo Emit parent method to update data.
 * @method initialSerialModal Open Serial modal.
 * Utilities
 * @method forceRender Force component to rerender.
 */
export default {
  name: "Redeem",
  components: {
    RedeemButton,
    Modal,
    ConfirmRedeemModal,
    SerialModal,
    ShippingAddressModal,
  },
  props: {
    lbl: Object,
    campaign: Object,
    selectedId: Number,
    selectedQuantity: Number,
    selectedPoint: Number,
  },
  data: function () {
    return {
      checkLoadingLogin: false,
      isLogin: false,
      objUser: {},
      availablePoint: 0,
      redeemBTN: {
        strRedeemLabel: "",
        isAllowRedeem: true,
        isButtonDisable: false,
        strDisableClass: "redeem-disable",
        isUseDefault: false,
      },
      redeemConfig: null,
      redeemShippingAdress: null,
      redeemInfoConfig: null,
      redeemLocation: null,
      redeemOtherConfig: null,
      campaignConfig: null,

      serialCampaign: {},
      isForceRender: true,

      shippingAddress: null,
      shippingAddressValidateInfo: {
        isValid: true,
        msg: "",
      },

      busModal: new Vue(),
      busConfirmRedeem: new Vue(),
      busSerialModal: new Vue(),
      busShippingModal: new Vue(),
    };
  },
  created: function () {
    Account.loginStatus().then((status) => {
      this.isLogin = status;
      this.checkLoadingLogin = true;
      if (this.isLogin == true) {
        this.objUser = Account.getCacheUser();
      }
    });
    this.availablePoint = Account.getCachePoint();
    this.redeemConfig = new RedeemConfigBuilder().create();
  },
    methods: {
        //Event
        clickRedeem: function () {

            if (this.campaign.type == 9) {
                window.open(this.campaign.defaultPrivilegeMessage);
                return;
            }
            if (!this.redeemBTN.isAllowRedeem) return;

                if (this.isLogin == true) {
                    var path = "";
                    // this.objUser.userLevel = 0;
                    if (this.objUser.userLevel <= 0) {
                        Account.setCacheCustomNostring("target_page", "campaign");
                        Account.setCacheCustomNostring("campaignId", this.campaign.id);
                        Account.setCacheCustomNostring("campaignType", this.campaign.type);
                        path = "/register";
                        this.$router.push(path);
                    }
                } else {
                    path = "/register";
                    this.$router.push(path);
                }
            this.busConfirmRedeem.$emit("showConfirmRedeemModal", {});
        },
        clickConfirmRedeem: function () {
            if (!this.redeemBTN.isAllowRedeem) return;

            var strRedeemCondition = this.checkRedeemCondition();
            switch (strRedeemCondition) {
            case "open_web":
                this.openWebsite();
                break;
            case "open_web_survey":
                this.openSurvey();
                break;
            case "call_api":
                this.callInterfaceApi();
                //No longer see this being use.
                break;
            case "update_shipping_address":
                this.initialShippingAddress();
                break;
            default:
                this.redeem();
                break;
            }
        },
        //Function
        checkRedeemCondition: function () {

            var strResult = "redeem";

            switch (this.campaign.type) {

                case Vue.CampaignType.Buy:
                    strResult = "open_web";
                    break;
                case Vue.CampaignType.Interface:
                    if (!this.campaign.interfaceDisplay) return;

                    if (this.campaign.interfaceDisplay === "web") strResult = "open_web";
                    if (
                        this.campaign.interfaceDisplay === "survey" ||
                        this.campaign.interfaceDisplay === "surveyapprove"
                    )
                    strResult = "open_web_survey";
                    if (this.campaign.interfaceDisplay === "api") strResult = "call_api";
                    break;
                default:
                    if (this.campaign.delivered) strResult = "update_shipping_address";
                    break;
            }

            return strResult;
        },
        openWebsite: function () {
            if (!this.campaign.website) return;

            var bzbsToken = Account.getToken();
            var localeCode = Locale.getLocaleCode();
            var returnUrl = encodeURIComponent(window.location.href);
            switch (this.campaign.type) {
                case Vue.CampaignType.Buy:
                var strUrl = "";
                var strLocale = "";
                var strEncryptToken = Util.shuffleToken(bzbsToken);
                switch (localeCode) {
                    case 1033:
                    strLocale = "E";
                    break;
                    case 1054:
                    strLocale = "T";
                    break;
                }

                if (this.campaign.website.indexOf(".buzzebees.com/payment/")) {

                    var arrSplittedUrl = this.campaign.website.split("/payment");

                    strUrl =Vue.bzbsConfig.bzbShoppingCartUrl +
                        "/payment" + arrSplittedUrl[1] +
                        "&token=" + strEncryptToken +
                        "&return_url=" + returnUrl +
                        "&locale=" + strLocale;
                } else {

                    strUrl = this.campaign.website =
                        "&token=" + strEncryptToken +
                        "&return_url=" + returnUrl +
                        "&locale=" + strLocale;
                }

                window.location = strUrl;
                break;

                case Vue.CampaignType.Interface:

                    var isShowHeader = "false"; //show/hide header.
                    var strTheme = "";
                    window.location.href =
                        this.campaign.website +
                        "&token=" + bzbsToken +
                        "&locale=" + localeCode +
                        "&header=" + isShowHeader +
                        "&theme=" + strTheme +
                        "&return_url=" + returnUrl; // ReturnUrl;
                break;
            }
        },
        openSurvey: function () {

        },
        callInterfaceApi: function () {

        },

        //Shipping
        initialShippingAddress: function () {
            this.shippingAddress = Account.getCacheProfileShippingAddres();
            this.busShippingModal.$emit("showShippingAddressModal", {});
        },
        clickConfirmAddress: function () {
            if (!this.shippingAddressValidateInfo.isValid) {

                this.showAlertModal(
                this.lbl.shipping.alert_headline,
                this.shippingAddressValidateInfo.msg,
                this.lbl.shipping.alert_ok_btn, "shipping");
            } else {
                this.redeemShippingAdress = new RedeemShippingAdressBuilder()
                .initialWithProfileShippingAddress(this.shippingAddress)
                .create();

                this.redeem();
            }
        },
        //Redeem
        redeem: function () {

            if (!this.redeemBTN.isAllowRedeem) return;

            var bzbsToken = Account.getToken();
            BzbsCampaign.apiRedeemCampaign(bzbsToken, this.selectedId, this.redeemConfig, this.redeemShippingAdress, null, null, null)

            .then((campaign) => {

                this.campaign.updateAfterRedeem(campaign);
                this.initialSerialModal();

                var self = this;
                    setTimeout(function () {
                        self.updateCampaign();
                    }, 1000);
                })
            .catch((error) => {
                console.log(error);

                if (!error.response) {
                    this.busModal.$emit("showAlertModal", this.$configModalNoConnect);
                }
            });
        },
        updateCampaign: function () {
            var strBzbsToken = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaign.id)
                .create();

            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig)
            .then((data) => {
                this.campaign.updateCampaign(data);
                this.updateCampaignInfo(data);
                this.forceRender();
                })
            .catch((error) => {
            console.log(error);
            });
        },
        updateCampaignInfo: function (campaign) {
            this.$emit("updateCampaignInfo", campaign);
        },
        initialSerialModal: function () {
            this.serialCampaign = this.campaign;
            this.busSerialModal.$emit("showSerialModal", this.serialCampaign);
        },
        //Utilities
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then(() => {
                this.isForceRender = true;
            });
        },
        // --- modal event ----
        modalConfirmOk: function (event) {

            if (event.tag == "modal-redeem") {
                this.clickConfirmRedeem();
            }
        },
        showConfirmModal: function (title, message, btnOk, btnCancel, tag) {

            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                strBtnCancel: btnCancel,
                tag: tag,
            };
            this.busModal.$emit("showConfirmModal", configModal);
        },
        showAlertModal: function (title, message, btnOk, tag) {

            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit("showAlertModal", configModal);
        },
        clickOkModalAlert: function (e) {

            switch (e.tag) {
                case "shipping":
                this.busShippingModal.$emit("showShippingAddressModal", {});
                break;
            }
        },
        showErrorInternet: function () {

            var configModal = {
                title: null,
                message: "พบปัญหาการเชื่อมต่อ",
                strBtnOk: "ปิด",
                tag: "nointernet",
            };
            this.busModal.$emit("showAlertModal", configModal);
        },
  }, // end methods
};
</script>
